import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import { ISP_INFO } from '../store/actions';
import ispReducer from '../store/ispReducer';
import axios from '../utils/axios';
import logger from '../utils/logger';

const initialState = {
  ispInfo: null
};

const IspContext = createContext(null);

const fetchIspInfo = async (subdomain) => {
  const response = await axios.get(`/synergy/isps/info`, {
    headers: {
      'Content-Type': 'application/json',
      'X-Synergy-Subdomain': subdomain
    }
  });
  return response.data;
};

export function IspProvider({ children }) {
  const [state, dispatch] = useReducer(ispReducer, initialState);

  const navigate = useNavigate();

  logger.debug('App domain', import.meta.env.VITE_DOMAIN);

  let subdomain = null;
  let accountType = null;

  if (import.meta.env.VITE_DOMAIN !== window.location.origin) {
    const sections = window.location.hostname.split('.');
    if (sections.length > 1) {
      subdomain = sections[0];
      accountType = 'isp';
    }
  }

  useEffect(() => {
    const updateFavicon = (iconUrl) => {
      // Remove existing favicon
      const existingFavicon = document.querySelector("link[rel*='icon']");
      if (existingFavicon) {
        existingFavicon.parentNode.removeChild(existingFavicon);
      }

      // Add new favicon
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = iconUrl;
      document.head.appendChild(link);
    };

    const init = async () => {
      if (!subdomain) {
        document.title = 'Synergy';
        return;
      }
      try {
        const ispInfo = await fetchIspInfo(subdomain);
        dispatch({
          type: ISP_INFO,
          payload: ispInfo
        });
        // Update document title and favicon with ISP info
        if (ispInfo?.ispName) {
          document.title = `${ispInfo.ispName} - Synergy`;
          // Update favicon if iconUrl exists
          if (ispInfo.logoUrl) {
            updateFavicon(ispInfo.logoUrl);
          }
        }
      } catch (err) {
        logger.error(err);
        // subdomain is not found
        navigate('pages/404');
      }
    };

    init();
  }, [accountType, subdomain, navigate]);
  return <IspContext.Provider value={{ ...state, accountType, subdomain }}>{children}</IspContext.Provider>;
}

IspProvider.propTypes = {
  children: PropTypes.node
};

export default IspContext;
